import React, { useState } from "react";

import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useDispatch } from "react-redux";
import { deleteAllDisruption } from "../../../store/actions/smrt/disruptionAction";
import { useTranslation } from "react-i18next";

const DeleteAllDisruption = () => {
  const { t } = useTranslation("smrtDisruption");
  const { t: tCommon } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const deleteAllEvent = () => {
    dispatch(deleteAllDisruption());
    handleClose();
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        fullWidth
        color="error"
        variant="contained"
        startIcon={<DeleteOutlineIcon fontSize="small" />}
        sx={{ boxShadow: 3 }}
      >
        {t("delete.allBtn")}
      </Button>

      <Dialog maxWidth="sm" open={open} onClose={handleClose}>
        <DialogTitle>{t("delete.confirmTitle")}</DialogTitle>

        <DialogContent>
          <DialogContentText>
            <Alert severity="warning">{t("delete.confirmText")}</Alert>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            fullWidth
            onClick={handleClose}
            variant="outlined"
            color="error"
          >
            {tCommon("cancelBtn")}
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="error"
            onClick={() => {
              deleteAllEvent();
            }}
          >
            {t("delete.confirmBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteAllDisruption;
